import type { ConnectorUsage } from "../types";

export function openaiUsage(): ConnectorUsage {
  return {
    measures: [
      { measure: "input_tokens", perModel: true },
      { measure: "cache_read_tokens", perModel: true },
      { measure: "output_tokens", perModel: true },
    ],
  };
}
